import React from 'react'
import { companyLogo } from '../../assets/images'
import { Link, useNavigate } from 'react-router-dom'
import { IconArrowBigLeftFilled, IconHome } from '@tabler/icons-react'

export default function Page404() {

    const navigate = useNavigate();

    return (
        <div className='flex min-h-svh items-center before:content-[""] before:fixed before:left-0 before:top-0 before:w-full sm:before:max-w-[400px] before:max-w-[100%] before:h-full before:z-[-1] before:bg-bg-auth after:content-[""] after:fixed after:right-0 after:top-0 after:w-full after:h-full after:z-[-2] after:bg-[url("../images/auth_bg.jpg")] after:bg-no-repeat after:bg-center'>
            <div className='w-full lg:max-w-[380px] sm:max-w-[80%] max-w-[90%] lg:ml-[130px] m-auto py-30'>
                <div className='sm:mb-30 mb-20'>
                    <img src={companyLogo} width="130" height="38" alt='company logo' className='invert' />
                </div>
                <div className='sm:p-30 p-20 bg-bg-dark shadow-light rounded-lg'>
                    <div className='mb-30 text-[28px]/[33.6px] font-medium'>
                        <p>
                            404 Oops!
                        </p>
                        <p>
                            Page Not Found
                        </p>
                    </div>
                    <p className='mb-30'>
                        The page you were looking for could not be found, please <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>contact us</Link> to report this issue.
                    </p>
                    <div className='flex flex-wrap gap-10'>
                        <button onClick={() => navigate(-1)} className='btn btn-outline-secondary'>
                            <IconArrowBigLeftFilled className="w-[16px] h-[16px]" />
                            Go Back
                        </button>
                        <Link to="/" className='btn btn-primary'>
                            <IconHome className='w-[18px] h-[18px] ' />
                            Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
